/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsUsers: {
  name: 'users';
  data: string;
} = {
  name: 'users',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.5 4a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0ZM5 .5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Zm5.5 6a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm1-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-1.47 6.384a3 3 0 0 1 4.439 2.187.5.5 0 1 0 .99-.142 4 4 0 0 0-6.137-2.784A6.476 6.476 0 0 0 5 8.5a6.478 6.478 0 0 0-4.333 1.655.5.5 0 0 0 .666.745A5.5 5.5 0 0 1 10.5 15a.5.5 0 0 0 1 0 6.473 6.473 0 0 0-1.47-4.116Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
